import React from "react";
import { Job as JobContainer } from "containers/Job/Job";
import { useRouter } from "lib/hooks/useRouter";
import { withUser } from "lib/hoc/withUser";

export const Job = withUser(({ user }) => {
  const { getParams } = useRouter("Job");
  const ref = getParams("ref");

  return <JobContainer user={user} jobRef={ref} />;
});
